export default __webpack_public_path__ + "static/media/versallesmanizales.8c7f96f5.jpg";